<script setup lang="ts">
import FormLabel from '@/components/FormLabel/FormLabel.vue';
import FormInputDisplay from '@/components/forms/display/FormInputDisplay.vue';
import { useFormMode } from '@/components/forms/useFormMode';
import { useField } from 'vee-validate';
import { toRef } from 'vue';
import TrackItUnitCombobox from './TrackItUnitCombobox.vue';

const props = defineProps<{
  name: string;
  label?: string;
}>();

const mode = useFormMode();

const { value, errorMessage, handleChange, handleBlur } = useField<string | null | undefined>(
  toRef(() => props.name),
  undefined,
  { validateOnValueUpdate: false },
);
</script>

<template>
  <FormLabel v-if="mode === 'details'" :label="label">
    <FormInputDisplay :value="value" />
  </FormLabel>
  <TrackItUnitCombobox
    v-else
    :modelValue="value"
    :label="label"
    :errorMessage="errorMessage"
    @update:modelValue="(unit) => handleChange(unit || undefined)"
    @blur="(event) => handleBlur(event, true)"
  />
</template>
